import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip"; // Importamos Tooltip
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import UtilModal from "verticales/UtilModal";
import InformesCards from "../InformesCards";
import fetchData from "verticales/FetchData";
import Zoom from "@mui/material/Zoom";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";

const url = "https://5djo5qwa3l.execute-api.us-east-1.amazonaws.com/dimo-goyito/ec2/";
let context = "deep-client";

// Componente CardEc2
function CardEc2({ label, title, description, action, extraInfo }) {
  const [openModal, setOpenModal] = React.useState(false);
  const [instanceData, setInstanceData] = useState(null);
  const [avgCpu, setAvgCpu] = useState();
  const [avgRam, setAvgRam] = useState();
  const [swEstado, setSwEstado] = useState();
  const [workload, setWorkload] = useState();
  const [actionLabel, setActionLabel] = useState();
  // console.log("Impresion Card Ec2...", title);

  useEffect(() => {
    const instanceId = title.split(" ")[0];
    const now = Math.floor(Date.now() / 1000);
    let fechaHoy = new Date();
    fechaHoy.setMinutes(0, 0, 0);
    fechaHoy.setHours(fechaHoy.getHours() - 1);
    const timeFinSeconds = fechaHoy.getTime();
    let timeIni = now * 1000;

    const params = {
      action: "get-ec2-estado",
      params: {
        instanceId: instanceId,
        timeIni: timeFinSeconds,
        timeFin: timeIni,
      },
    };

    const fetchInstanceData = async () => {
      try {
        const result = await fetchData(url, context, params);
        console.log(`Datos de la instancia (${title}):`, result);
        const promCpu = result.rows[0].avgCpu.toFixed(2);
        const promRam = result.rows[0].avgRam.toFixed(2);
        const estado = result.rows[0].swEstado;
        const cargaTrabajo = result.rows[0].workload;

        console.log(`Carga de trabajo:`, estado);
        setInstanceData(result);
        setAvgCpu(promCpu);
        setAvgRam(promRam);
        setSwEstado(estado);
        setWorkload(cargaTrabajo);
      } catch (error) {
        console.error(`Error al obtener datos de la instancia (${title}):`, error);
      }
    };

    fetchInstanceData();
  }, [title]);

  // Función para abrir el modal
  const handleOpenModal = () => {
    setOpenModal(true);
  };

  // Función para cerrar el modal
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  // Concatenar todos los datos que quieres mostrar en el Tooltip
  const tooltipContent = `
    Tipo de instancia: ${extraInfo.instanceType}
    Producto: ${extraInfo.producto}
    vCPUs: ${extraInfo.vcpus},
    Cores: ${extraInfo.cores},
    memory: ${extraInfo.memory} MB,
    Discos: ${extraInfo.diskInfo}
  `;

  const renderView = () => {
    return <InformesCards data={instanceData} handleCloseModal={handleCloseModal} />;
  };

  return (
    <>
      <Card
        sx={{
          display: "flex",
          flexDirection: "column",
          backgroundColor: "transparent",
          overflow: "visible",
          border: "1px solid #dfdfdf",
        }}
      >
        <MDBox mt={1} mx={1.5}>
          <MDTypography
            variant="button"
            fontWeight="regular"
            color="text"
            textTransform="capitalize"
          >
            {label}
          </MDTypography>
          <MDBox mb={1}>
            <MDTypography variant="h5" textTransform="capitalize">
              {title}
            </MDTypography>
          </MDBox>
          <MDBox mb={2} lineHeight={0}>
            <Tooltip
              title={tooltipContent}
              TransitionComponent={Zoom}
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    maxWidth: 600,
                  },
                },
              }}
            >
              <MDTypography variant="button" fontWeight="light" color="text">
                {description}
              </MDTypography>
            </Tooltip>
          </MDBox>
          {/* Usamos Tooltip aquí para mostrar la información adicional */}
          <MDBox mb={1}>
            <Grid container>
              <MDTypography
                variant="subtitle1"
                textTransform="capitalize"
                sx={{ whiteSpace: "pre", fontSize: "1rem" }}
              >
                {"Cargas Productivas:  "}
              </MDTypography>
              <MDTypography
                variant="subtitle1"
                color="sucess"
                textTransform="capitalize"
                sx={{ fontSize: "1rem" }}
              >
                {"Cpu:  "}
                {avgCpu || "Cargando Cpu..."}
                {" - "} {"Ram: "} {"  "} {avgRam || "Cargando Ram..."}
              </MDTypography>
              <MDTypography variant="h7" textTransform="capitalize" sx={{ whiteSpace: "pre" }}>
                {"Status:  "}
              </MDTypography>
              <MDTypography
                variant="h7"
                color="error"
                textTransform="capitalize"
                sx={{
                  color:
                    swEstado === "Alto"
                      ? "red"
                      : swEstado === "Ok"
                      ? "green"
                      : swEstado === "Bajo"
                      ? "blue"
                      : "text.primary",
                }}
              >
                {swEstado || "Cargando estado..."}
                <br></br>
              </MDTypography>
            </Grid>
            <Grid>
              <MDTypography variant="h7" textTransform="capitalize" sx={{ whiteSpace: "pre" }}>
                {"Workload:  "}
              </MDTypography>
              <MDTypography
                variant="h7"
                color="sucess"
                textTransform="capitalize"
                sx={{
                  fontSize: "1rem",
                  color:
                    workload === "Alto"
                      ? "red"
                      : workload === "Ok"
                      ? "green"
                      : workload === "Bajo"
                      ? "blue"
                      : "text.primary",
                }}
              >
                {workload || "Mostrando carga..."}
              </MDTypography>
              <MDTypography variant="h6" textTransform="capitalize" sx={{ whiteSpace: "pre" }}>
                {"Costo:  En construcción"}
              </MDTypography>
            </Grid>
          </MDBox>
          {/* Botón para abrir el modal */}
          <MDBox mb={2}>
            <MDButton
              onClick={handleOpenModal}
              target="_blank"
              rel="noreferrer"
              variant="outlined"
              size="small"
              color={action.color}
            >
              <MDTypography variant="h7" textTransform="capitalize">
                Ver Informes
              </MDTypography>
            </MDButton>
          </MDBox>
        </MDBox>

        {/* Modal con renderView */}
        <UtilModal
          openModal={openModal}
          handleCloseModal={handleCloseModal}
          renderView={renderView}
        />
      </Card>
      {/* <CardRds /> */}
    </>
  );
}
const CardRds = () => {
  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "coral",
        overflow: "visible",
        border: "1px solid #dfdfdf",
      }}
    >
      <MDBox mt={1} mx={1.5}>
        <MDTypography variant="button" fontWeight="regular" color="text" textTransform="capitalize">
          {"Card RDS"}
        </MDTypography>

        <MDBox mb={1}>
          <MDTypography variant="h5" textTransform="capitalize">
            {"En construcción"}
          </MDTypography>
        </MDBox>

        <MDBox mb={2} lineHeight={0}>
          <Tooltip
            title={"Próximamente detalles de RDS disponibles."}
            TransitionComponent={Zoom}
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  maxWidth: 400,
                },
              },
            }}
          >
            <MDTypography variant="button" fontWeight="light" color="text">
              {"Estamos trabajando en esta funcionalidad..."}
            </MDTypography>
          </Tooltip>
        </MDBox>
      </MDBox>
    </Card>
  );
};

// Propiedades predeterminadas para CardEc2
CardEc2.defaultProps = {
  action: {},
  extraInfo: {},
};

// Validación de las propiedades
CardEc2.propTypes = {
  label: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  action: PropTypes.shape({
    color: PropTypes.oneOf([
      "primary",
      "secondary",
      "info",
      "success",
      "warning",
      "error",
      "light",
      "dark",
      "white",
    ]).isRequired,
    label: PropTypes.string.isRequired,
  }).isRequired,
  extraInfo: PropTypes.shape({
    instanceType: PropTypes.string.isRequired,
    producto: PropTypes.string.isRequired,
    cores: PropTypes.number.isRequired,
    memory: PropTypes.number.isRequired,
    vcpus: PropTypes.number.isRequired,
    diskInfo: PropTypes.string.isRequired,
  }).isRequired,
};

export default CardEc2;
